//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "Classic",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '7',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-7.vue